import React from 'react';
import {
  List, ListItem, ListItemText, Typography, Chip,
  Skeleton, Box, Tooltip, Divider
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  transition: '0.3s',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  padding: theme.spacing(2),
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));

const GoldText = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.warning.main,
}));

const BattlenetIdText = styled(Typography)(({ theme }) => ({
  color: theme.palette.info.main,
  fontStyle: 'italic',
}));

const ItemList = ({ data, loading, handleClickOpen, pageSize, formatGold }) => {
  return (
    <List disablePadding>
      {loading ? (
        Array.from(new Array(pageSize)).map((_, index) => (
          <ListItem key={index} divider>
            <Skeleton variant="rectangular" width="100%" height={80} />
          </ListItem>
        ))
      ) : (
        data.map((item) => (
          <React.Fragment key={item.id}>
            <StyledListItem
              button
              onClick={() => handleClickOpen(item)}
            >
              <ListItemText
                primary={
                  <Tooltip title={item.title} placement="top-start">
                    <Typography variant="subtitle1" noWrap>
                      {item.title}
                    </Typography>
                  </Tooltip>
                }
                secondary={
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                    <BattlenetIdText variant="body2">
                      BattlenetID: {item.gameId}
                    </BattlenetIdText>
                    <GoldText variant="body2">
                      {formatGold(item.gold)} gold
                    </GoldText>
                  </Box>
                }
              />
              <StyledChip
                label={item.completed ? '판매 완료' : '거래 가능'}
                color={item.completed ? 'secondary' : 'primary'}
                size="small"
              />
            </StyledListItem>
            <Divider />
          </React.Fragment>
        ))
      )}
    </List>
  );
};

export default ItemList;
